import { RQ } from 'utils';

export default {
  /**
   * 获取视频列表
   * @params
   * {
   *   excludeMaterialId(当前视频materialId), page, pageSize, enterpriseNo, materialType(1图文，2视频)
   * }
   **/
  async getList (page) {
    const { materialType = 2 } = this.$route.query;
    const { enterprise } = this;
    this.isLoading = true;
    const res = await RQ.mall.get('/api/h5/material/getMaterialList',
      { page, pageSize: 20, materialType, enterpriseNo: enterprise },
      {jsonBody: true, enterprise: '', loading: false}
      );
    if (res.code === 0) {
      if (page === 1) {
        this.videoList = res;
      } else {
        const pageData = this.videoList.data.pageData.concat(res.data.pageData);
        const data = Object.assign({}, res.data, {pageData})
        this.videoList = Object.assign({}, res, {data});
      }
    }
    this.isLoading = false;
    console.log('---------video list get list', res)
    return res;
  },
  onChangedList (data) {
    this.list = data;
  },
  handleToVideo (item) {
    this.$router.push({
      path: `/wp/app/video/${item.materialId}`,
      query: {
        ...item
      }
    });
    // console.log('----------handleToVideo', window)
    // if (window.__wxjs_environment === 'miniprogram') {
    //   console.log('----------handleToVideo2', wx.miniProgram)
    //   wx.miniProgram.postMessage({msg: '我是来自h5的消息'});
    //   // wx.miniProgram.navigateTo({url: `${path}&original=wxapp`});
    // }
  }
};



// WEBPACK FOOTER //
// ./src/module/app/videoList/action.js